import { render, staticRenderFns } from "./invoices-view.vue?vue&type=template&id=226f61be"
import script from "./invoices-view.vue?vue&type=script&lang=js"
export * from "./invoices-view.vue?vue&type=script&lang=js"
import style0 from "./invoices-view.vue?vue&type=style&index=0&id=226f61be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports